import { define } from 'wicked-elements'

define('[data-component~="video-embed"]', {
  init() {
    this.$button = this.element.querySelector('button')
    this.$poster = this.element.querySelector('.img-container')
    this.$iframe = this.element.querySelector('iframe')
    this.handleClick = this.handleClick.bind(this)
  },
  connected() {
    this.$button.addEventListener('click', this.handleClick)
  },
  disconnected() {
    this.$button.removeEventListener('click', this.handleClick)
  },
  handleClick() {
    this.$iframe.src = this.$iframe.getAttribute('data-src')
    this.$iframe.style.display = 'block'
    this.$poster.style.display = 'none'
    this.$button.style.display = 'none'
  },
})
